import { ModalFooter, ModalFooterProps } from '@chakra-ui/react';
import React from 'react';

export const CmModalFooter: React.FC<ModalFooterProps> = ({
  children,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <ModalFooter {...rest}>{children}</ModalFooter>;
};
